import { HttpClient, provideHttpClient } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MessageService } from 'primeng/api';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ToastModule } from 'primeng/toast';
import { TooltipModule as PrimeNgTooltipModule } from 'primeng/tooltip';
import { ApiAuthorizationModule } from 'src/api-authorization/api-authorization.module';
import { PipesModule } from 'src/app/shared/modules/pipes/pipes.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterModule } from './shared/core/footer/footer.module';
import { HeaderModule } from './shared/core/header/header.module';
import { LoaderModule } from './shared/core/loader/loader.module';
import { MetaDataService } from './shared/core/services/meta-data.service';
import { SessionService } from './shared/core/services/session.service';
import { SiteDataService } from './shared/core/services/site-data.service';
import { WebAPIService } from './shared/core/services/web-api.service';
import { MfaEnrollmentInterstitialComponent } from './shared/modules/components/mfa-enrollment-interstitial/mfa-enrollment-interstitial.component';
import { TooltipModule } from './shared/modules/components/tooltip/tooltip.module';
import {ComponentsModule} from "./shared/modules/components/components.module";
import { LeftNavModule } from './shared/core/left-nav/left-nav.module';
import {ApplicationInsightsErrorHandler} from "./shared/core/services/application-insights-error-handler";
import { DevPanelModule } from './shared/core/dev-panel/dev-panel.module';
import {providePrimeNG} from "primeng/config";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import { IchraxTheme } from './ichrax-theme';
import { TranslateLoader, TranslateModule } from 'node_modules/@ngx-translate/core';
import { UserService } from './admin/user/user.service';
import { QueryClient, provideTanStackQuery } from '@tanstack/angular-query-experimental';
import { provideLinkedQueryParamConfig } from 'ngxtension/linked-query-param';
// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        FormsModule,
        ApiAuthorizationModule,
        AppRoutingModule,
        LoaderModule,
        BrowserAnimationsModule,
        ToastModule,
        HeaderModule,
        FooterModule,
        TooltipModule,
        PrimeNgTooltipModule,
        SplitButtonModule,
        PipesModule,
        ComponentsModule,
        LeftNavModule,
        DevPanelModule,
        MfaEnrollmentInterstitialComponent,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
    ],
    exports: [FormsModule],
    providers: [
        { provide: ErrorHandler, useClass: ApplicationInsightsErrorHandler },
        provideHttpClient(),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: IchraxTheme,
                options: {
                    darkModeSelector: false || 'none'
                }
            }
        }),
        // Query params describe the current view, so updating them replaces the history entry
        // rather than adding one — paging and filtering must not fill up the Back button.
        // A param that genuinely warrants a history entry can pass replaceUrl: false itself.
        provideLinkedQueryParamConfig({ replaceUrl: true }),
        // WebAPIService redirects on 401/403/404 from inside the observable, so a retry
        // re-fires that navigation. Only 5xx — which never redirects — may be retried.
        provideTanStackQuery(new QueryClient({
            defaultOptions: {
                queries: {
                    retry: (count, err: any) => err?.status >= 500 && count < 2,
                },
            },
        })),
        SiteDataService,
        WebAPIService,
        MessageService,
        SessionService,
        Title,
        UserService,
        MetaDataService,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
	constructor() {
	}
}
